module.exports = __webpack_public_path__ + "OceanHeart.jpg?a0896f5d09fc036ea98913000525803a";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/OceanHeart.jpg
// module id = 538
// module chunks = 0